<template>
  <div class="container_home">
    <!-- 左侧工具栏 -->
    <!-- <div>
      <LeftBar ref="LeftBar_c" @change_conversation="change_conversation" @showNavUrl="showNavUrl" @hideIframe="hideIframe" />
    </div> -->

    <!-- 右侧子界面 -->
    <div style="height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: start; box-sizing: border-box">
      <div style="display: flex; flex-direction: row; justify-content: center; margin: auto; width: 100%; flex: 1; min-height: 0; overflow: hidden">
        <!-- 科学导航iframe显示区域 -->
        <div v-if="currentNavUrl" style="width: 100%; height: 100%">
          <iframe :src="currentNavUrl" ref="userCenterIframe" class="iframe-container" style="width: 100%; height: 100%; border: none"></iframe>
        </div>

        <!-- 文章详情显示区域 -->
        <div v-else-if="currentArticle" style="width: 100%; height: 100%; position: relative">
          <iframe ref="childIframe" :src="currentArticle.url" style="width: 100%; height: 100%; border: none"></iframe>
        </div>

        <!-- 会话内容显示区域 -->
        <template v-else>
          <!-- URL 带着会话 id 但侧边栏数据还没回来，先占位，避免白屏之后再闪一下 -->
          <div v-if="isRestoringFromRoute" class="home-restoring">
            <i class="el-icon-loading"></i>
            <span>正在恢复会话</span>
          </div>
          <div v-for="(conversation_id, idx) in conversation_id_list" v-show="conversation_id === cur_conversation_id" :key="conversation_id" style="width: 100%; height: 100%; min-height: 0">
            <!-- {{ conversation_id }} -->
            <Conversation :conversation_id="conversation_id" :tool_idx="tool_idx_list[idx]" :tool_list="tool_list" :is_restored="!!restored_conversation_ids[conversation_id]" @updateConversationHistory="updateConversationHistory" />
            <!-- {{ key }}: {{ conv_data }} -->
          </div>
        </template>
      </div>

      <!-- <testtt /> -->
    </div>

    <!-- <div>
      <TEST/>
    </div> -->

    <!-- <div style="display: flex; flex-direction: row; justify-content: center; height: 100vh; margin: auto;">

      <div :class="{'big_chat_box': showWorkBench === false, 'small_chat_box': showWorkBench === true}">
        <ChatBox @renderWorkbenchData="renderWorkbenchData" @updateConversationHistory="updateConversationHistory" :user_id="user_id" :conversation_id="conversation_id"/>
      </div>

      <div v-show="showWorkBench">
        <WorkBench :workbenchData="workbenchData" @clossWorkBench="clossWorkBench" />
      </div>

    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
// 引入子组件
import ChatBox from "../components/ChatBox.vue";
import WorkBench from "../components/WorkBench.vue";
import LeftBar from "../components/LeftBar.vue";
import Conversation from "../components/Conversation.vue";
import ThemeChange from "../components/ThemeChange.vue";
import EventBus from "../eventBus/EventBus.js";
import { findLeftBarRef } from "../utils/leftBarRef";
export default {
  name: "HomePage",
  // 注册子组件
  components: {
    LeftBar,
    ChatBox,
    WorkBench,
    Conversation,
    ThemeChange,
    // UserAvatar,
    // TEST
    // testtt
    // MDTest
  },
  watch: {
    "$route.fullPath"() {
      if (this.$route.path === "/ai_home" || this.$route.path === "/topic-assistant") {
        this.restoreHomeRouteState();
      }
    },
  },
  data() {
    return {
      // 用户id和会话id
      // user_id: '123',
      cur_conversation_id: null,
      cur_tool_idx: null,
      tool_list: [],
      conversation_id_list: [],
      tool_idx_list: [],
      // 当前科学导航URL
      currentNavUrl: null,
      // 当前文章详情
      currentArticle: null,
      // 返回状态
      backState: {
        conversation_id: null,
        navUrl: null,
        workbenchData: null,
      },
      userName: "",
      userToken: "",
      avater: "",
      // 侧边栏历史是否已经回来过一次。URL 里带 cid 时要靠它区分"还在加载"和"确实没有这条会话"。
      sidebarHistoryLoaded: false,
      // 哪些会话是"打开已有会话"而非新建：历史记录点击、最近查询点击、URL 恢复、跨路由
      // 交接都算。ChatBox 据此在挂载时直接进聊天态，不先闪一帧欢迎页。
      restored_conversation_ids: {},
    };
  },
  mounted() {
    this.restoreHomeRouteState();
    window.addEventListener("message", this.handleIframeMessage);
    // 侧边栏的会话历史和工具列表都是异步回来的，回来后要再试一次 URL 会话恢复。
    EventBus.$on("conversationHistoryLoaded", this.handleSidebarHistoryLoaded);
    EventBus.$on("toolListLoaded", this.handleSidebarDataLoaded);
    // 加载用户昵称显示头像
    EventBus.$on("change_conversation", this.change_conversation);
    EventBus.$on("showNavUrl", this.showNavUrl);
    // 监听文章详情显示事件
    EventBus.$on("showArticleDetail", this.showArticleDetail);
    // 监听文章详情隐藏事件
    EventBus.$on("hideArticleDetail", this.hideArticleDetail);
  },
  activated() {
    this.restoreHomeRouteState();
  },
  beforeDestroy() {
    // 销毁组件时移除监听，避免内存泄漏
    window.removeEventListener("message", this.handleIframeMessage);
    // 移除事件监听
    EventBus.$off("conversationHistoryLoaded", this.handleSidebarHistoryLoaded);
    EventBus.$off("toolListLoaded", this.handleSidebarDataLoaded);
    EventBus.$off("change_conversation", this.change_conversation);
    EventBus.$off("showNavUrl", this.showNavUrl);
    EventBus.$off("showArticleDetail", this.showArticleDetail);
    EventBus.$off("hideArticleDetail", this.hideArticleDetail);
  },
  computed: {
    isRestoringFromRoute() {
      return this.$route.path === "/ai_home" && !!this.$route.query.cid && this.cur_conversation_id == null && !this.currentNavUrl && !this.currentArticle;
    },
  },
  methods: {
    restoreHomeRouteState() {
      if (this.consumePendingHistoryConversation()) {
        return;
      }
      if (sessionStorage.getItem("topic_assistant_params")) {
        const { tool_idx, tool_list } = JSON.parse(sessionStorage.getItem("topic_assistant_params"));
        sessionStorage.removeItem("topic_assistant_params");
        this.showTopicAssistant(tool_idx, tool_list);
      } else if (this.$route.path === "/topic-assistant") {
        this.ensureTopicAssistantState();
      } else if (!this.restoreConversationFromRoute()) {
        this.ensureDefaultHomeState();
      }
    },
    // 会话身份写进 URL，刷新时才能恢复。用 replace 而不是 push，避免每切一次会话就往历史栈塞一条。
    syncConversationIdToRoute(conversationId) {
      if (this.$route.path !== "/ai_home") return;
      const currentCid = this.$route.query.cid == null ? null : String(this.$route.query.cid);
      const nextCid = conversationId == null ? null : String(conversationId);
      if (currentCid === nextCid) return;

      const query = Object.assign({}, this.$route.query);
      if (nextCid == null) {
        delete query.cid;
      } else {
        query.cid = nextCid;
      }
      this.$router.replace({ path: this.$route.path, query }).catch(() => {});
    },
    // 返回 true 表示"这一轮不要再新建会话"：要么已恢复，要么侧边栏数据还没回来需要等下一次事件重试。
    restoreConversationFromRoute() {
      if (this.$route.path !== "/ai_home") return false;
      const cid = this.$route.query.cid;
      if (!cid) return false;
      if (this.currentNavUrl || this.currentArticle) return false;
      if (this.cur_conversation_id != null && String(this.cur_conversation_id) === String(cid)) return true;

      const leftBarRef = findLeftBarRef(this);
      if (!leftBarRef) return true;
      const toolList = Array.isArray(leftBarRef.tool_list) ? leftBarRef.tool_list : [];
      if (toolList.length === 0) return true;
      if (!this.sidebarHistoryLoaded) return true;

      const history = Array.isArray(leftBarRef.conversation_history) ? leftBarRef.conversation_history : [];
      const target = history.find(conv => conv && String(conv.conversation_id) === String(cid));
      if (!target) {
        // URL 上的会话不属于当前用户或者已被删除，清掉参数，让默认逻辑接管。
        this.syncConversationIdToRoute(null);
        return false;
      }

      if (typeof leftBarRef.change_conversation === "function") {
        leftBarRef.change_conversation(target.conversation_id, target.tool_idx, toolList);
      } else {
        this.change_conversation(target.conversation_id, target.tool_idx, toolList, true);
      }
      this.hideIframe();
      return true;
    },
    handleSidebarHistoryLoaded() {
      this.sidebarHistoryLoaded = true;
      this.handleSidebarDataLoaded();
    },
    handleSidebarDataLoaded() {
      if (this.$route.path !== "/ai_home") return;
      if (!this.restoreConversationFromRoute()) {
        this.ensureDefaultHomeState();
      }
    },
    ensureDefaultHomeState() {
      if (this.$route.path !== "/ai_home" || this.currentNavUrl || this.currentArticle || this.cur_conversation_id != null) {
        return;
      }

      // 新建默认会话统一收口到 LeftBar，避免这里和 LeftBar.get_tool_list 各建一个。
      const leftBarRef = findLeftBarRef(this);
      if (!leftBarRef || typeof leftBarRef.ensureDefaultAcademicConversation !== "function") {
        return;
      }
      leftBarRef.ensureDefaultAcademicConversation();
    },
    ensureTopicAssistantState() {
      if (this.$route.path !== "/topic-assistant" || this.currentNavUrl || this.currentArticle || this.cur_conversation_id != null) {
        return;
      }

      const leftBarRef = findLeftBarRef(this);
      if (!leftBarRef || !Array.isArray(leftBarRef.tool_list) || leftBarRef.tool_list.length === 0) {
        return;
      }

      const topicAssistantIdx = leftBarRef.tool_list.findIndex(tool => tool && tool.function === "topic_selection_assistance");
      if (topicAssistantIdx === -1) {
        return;
      }

      leftBarRef.add_conversation(topicAssistantIdx, leftBarRef.tool_list);
    },
    consumePendingHistoryConversation() {
      if (!sessionStorage.getItem("pending_history_conversation")) return false;

      const { conversation_id, tool_idx, tool_list } = JSON.parse(sessionStorage.getItem("pending_history_conversation"));
      sessionStorage.removeItem("pending_history_conversation");
      sessionStorage.removeItem("topic_assistant_params");
      this.change_conversation(conversation_id, tool_idx, tool_list, true);
      this.hideIframe();
      return true;
    },
    handleIframeMessage(event) {
      // 1. 验证消息来源（重要！防止跨域攻击）
      // 替换为你实际的个人中心域名，如：'http://localhost:8081'
      const allowedOrigin = this.globalUrl.frontRootUrl;
      if (event.origin !== allowedOrigin) return;

      // 2. 验证消息类型，确保是“资料修改”的消息
      if (event.data.type === "REDIRECT_STATUS") {
        let status = event.data.data.status;
        if (status === "REDIRECTING_TO_LOGIN") {
          const token = localStorage.getItem("token");
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
              token: token,
            },
          };
          this.$http.get(this.globalUrl.get_user_info, {}, config).then(res => {
            const { ip_user, displayName } = res.data.user_info;
            localStorage.setItem("ip_user", ip_user);
            if (ip_user != 1) {
              const checkTokenUrl = this.globalUrl.checkTokenUrl + "?unionid=" + res.data.user_info.unionid;
              // 创建隐藏的 iframe 执行退出
              const checkTokenIframe = document.createElement("iframe");
              checkTokenIframe.style.cssText = "position:absolute;width:0;height:0;border:0;visibility:hidden;";
              checkTokenIframe.src = checkTokenUrl;
              document.body.appendChild(checkTokenIframe);
            }
          });
        }
      }
    },

    // 切换会话，渲染到右侧界面
    change_conversation(conversation_id, tool_idx, tool_list, is_existing) {
      // 会话 id 有两个来源且类型不同：/conversation/add 建的老会话是 MySQL 自增 id(数字)，
      // 学术搜索走 ragsearch 的会话 id 是字符串，select_all 把两者合并返回。同一个会话经
      // "新建"和"点历史记录"两条路径进来时类型就会不一致，不统一会同时踩两个坑：
      //   1) 下面 indexOf 是严格相等，数字 28302 找不到已存在的字符串 "28302"，往列表里塞重复项；
      //   2) :key 同时存在数字和字符串，Vue 内部 key map 以字符串做键会把两者视为同一个 key，
      //      patch 时 DOM 复用错配，表现为两个会话面板同时显示、内容串台。
      const normalizedId = conversation_id == null ? conversation_id : String(conversation_id);
      // 打开的是已经有内容的会话，标记一下：ChatBox 挂载时就按聊天态渲染，
      // 否则会先渲染一帧居中的欢迎页，等消息接口回来才跳成聊天态。
      if (is_existing && normalizedId != null) this.$set(this.restored_conversation_ids, normalizedId, true);
      this.cur_conversation_id = normalizedId;
      this.cur_tool_idx = tool_idx;
      this.tool_list = tool_list;
      this.currentNavUrl = null; // 切换会话时隐藏iframe
      this.currentArticle = null; // 切换会话时隐藏文章详情
      // 只请求没被加载过的会话（懒加载）
      const conversationIndex = this.conversation_id_list.indexOf(normalizedId);
      if (conversationIndex == -1) {
        // this.$set(this.conversation_id_list, this.conversation_id_list.length, conversation_id);
        this.conversation_id_list.push(normalizedId);
        this.tool_idx_list.push(tool_idx);
      } else {
        this.$set(this.tool_idx_list, conversationIndex, tool_idx);
        // this.$set(this.conversation_id_list, conversation_id);
      }
      this.syncConversationIdToRoute(normalizedId);
    },

    // 更新会话历史
    updateConversationHistory() {
      const leftBarRef = findLeftBarRef(this);
      if (leftBarRef && typeof leftBarRef.select_conversation_all === "function") {
        leftBarRef.select_conversation_all();
      }
    },

    // 显示科学导航URL
    showNavUrl(url) {
      this.currentNavUrl = url;

      this.cur_conversation_id = null; // 隐藏会话内容
      this.currentArticle = null; // 隐藏文章详情
    },

    // 隐藏iframe
    hideIframe() {
      this.currentNavUrl = null;
    },
    // 显示文章详情
    showArticleDetail(article) {
      // 保存当前状态
      this.backState = {
        conversation_id: this.cur_conversation_id,
        navUrl: this.currentNavUrl,
      };
      this.currentArticle = article;
      this.currentNavUrl = null; // 隐藏科学导航
      this.cur_conversation_id = null; // 隐藏会话内容
    },

    // 返回到之前的页面
    goBack() {
      if (this.backState.navUrl) {
        this.currentNavUrl = this.backState.navUrl;
      }
      if (this.backState.conversation_id) {
        this.cur_conversation_id = this.backState.conversation_id;
      }
      this.currentArticle = null;
    },

    // 隐藏文章详情
    hideArticleDetail() {
      this.currentArticle = null;
    },
    // 显示专题助手
    showTopicAssistant(tool_idx, tool_list) {
      this.cur_tool_idx = tool_idx;
      this.tool_list = tool_list;
      this.$http.get(this.globalUrl.cxai_conversation_add).then(res => {
        // 不在这里直接赋值 cur_conversation_id，交给 change_conversation 统一做类型归一
        this.change_conversation(res.data, tool_idx, tool_list);
        this.hideIframe(); // 切换会话时隐藏iframe
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-restoring {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  color: #8b95a7;
  font-size: 14px;
}
.container_home {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(rgb(255, 255, 255) 0%, rgb(232, 240, 254, 0.5) 100%);
}
/* .parent-component {
  padding: 2rem;
} */

/* 返回按钮样式 */
.back-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #303133;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.back-btn:hover {
  background: #f5f7fa;
  color: #409eff;
}

.big_chat_box {
  width: 100%;
  max-width: 800px;
  /* margin: 20px; */
}

.small_chat_box {
  width: 100%;
  max-width: 600px;
  /* margin: 20px; */
}

/* .float-right-top {
  position: fixed;
  left: 50px;
  top: -27px;
  color: var(--light);
  text-align: center;
  line-height: 100px;
} */
.top_tool_box {
  /* 可选：添加样式让元素更明显 */
  color: var(--light);
  /* text-align: center; */
  display: flex;
  flex-direction: row;
  justify-content: right;
  background-color: var(--bg-back);
  padding: 5px 20px;
  border: 1px solid var(--bg-front);
}
</style>
